<template>
    <section content padding>
        <div class="d-block align-center">
            <h1 class="size-40">{{ $common.config.lang === 'cn' ? '联系我们' : 'Contact Us' }}</h1>
        </div>
        <Row>
            <Col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="public-shell" padding margin border radius shadow>
                    <div class="d-block align-center">
                        <p><img src="/static/icon/look-blue@64px.svg"/></p>
                        <h1>{{ $common.config.lang === 'cn' ? '订购演示' : 'Order a demo' }}</h1>
                        <br/>
                        <h2>{{ $common.config.lang === 'cn' ? '现场展示产品' : 'Show the product live' }}</h2>
                        <br/>
                        <p>
                            <Button shape="circle" size="large" type="default" @click="toggleContact(1)">{{ $common.config.lang === 'cn' ? '立即订购' : 'Order a demo' }}</Button>
                        </p>
                    </div>
                </div>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="public-shell" padding margin border radius shadow>
                    <div class="d-block align-center">
                        <p><img src="/static/icon/tel-blue@64px.svg"/></p>
                        <h1>{{ $common.config.lang === 'cn' ? '请求回电' : 'Request a call back' }}</h1>
                        <br/>
                        <h2>{{ $common.config.lang === 'cn' ? '请求回电' : 'We will help you figure it out' }}</h2>
                        <br/>
                        <p>
                            <Button shape="circle" size="large" type="default" @click="toggleContact(2)">{{ $common.config.lang === 'cn' ? '提交请求' : 'Request a call back' }}</Button>
                        </p>
                    </div>
                </div>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="public-shell" padding margin border radius shadow>
                    <div class="d-block align-center">
                        <p><img src="/static/icon/message-blue@64px.svg"/></p>
                        <h1>{{ $common.config.lang === 'cn' ? '在线留言' : 'Ask a question' }}</h1>
                        <br/>
                        <h2>{{ $common.config.lang === 'cn' ? '在线留言' : 'We will answer your questions' }}</h2>
                        <br/>
                        <p>
                            <Button shape="circle" size="large" type="default" @click="toggleContact(3)">{{ $common.config.lang === 'cn' ? '在线留言' : 'Ask a question' }}</Button>
                        </p>
                    </div>
                </div>
            </Col>
        </Row>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            toggleContact(type){
                console.log('this.toggleContact---------->', type);
                this.$bus.emit('toggleContact', true, type);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue